import StrongPasswordValidator from "./StrongPasswordValidator";

export const strongPassword = function(value: unknown, minPasswordLength: unknown) {
    return typeof value === "string" && typeof minPasswordLength === "number" && StrongPasswordValidator(value, minPasswordLength);
}